<div class="container">

    <img src="https://instafamous.pro/images/success-tick-noloop.gif" class="img-info">
    <div class="content">{{contenu}}</div>

</div>
